import { Component, OnInit } from '@angular/core';
import { NavController, Platform } from '@ionic/angular';
// import { NativePageTransitions, NativeTransitionOptions } from '@ionic-native/native-page-transitions/ngx';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UserService } from 'src/app/services/user/user.service';
import { UserAddressService } from 'src/app/services/user-address/user-address.service';
import { AlertComponent } from 'src/app/shared/alert/alert.component';
import { Config } from 'src/app/core/config';
import { AreaService } from 'src/app/services/Area/area.service';

declare var SMSReceive:any;
import { SmsRetriever } from '@ionic-native/sms-retriever/ngx';

declare var document:any;
@Component({
  selector: 'app-otp',
  templateUrl: './otp.page.html',
  styleUrls: ['./otp.page.scss'],
})
export class OtpPage implements OnInit {
  mobileObj:any;
  otpInput : any = {};
  otp:any='';
  detectedmsg:any;
  mobile:any;
  buttonflag:boolean = false;
  constructor(
    private navCtrl: NavController, 
    // private nativePageTransitions: NativePageTransitions,
    private activatedroute:ActivatedRoute,
    private userService:UserService,
    private userAddressService:UserAddressService,
    private smsRetriever: SmsRetriever,
    public platform:Platform    ,
    private alert:AlertComponent,
    private r:Router,
    private areaService:AreaService

    ) { 
      this.activatedroute.queryParams.subscribe((x:Params)=>{
        if(Object.keys(x).length > 0){
          this.mobileObj = JSON.parse(x.mobileObj);
        }
      })
    this.initOtpInput();

    }
    // (click)="selecttype()"
  ngOnInit() {
  }
  ionViewDidEnter() {

    this.areaService.showHome=false  

    // if(this.platform.is('android')){
      this.smsRetriever.startWatching()
  .then((res: any) =>{
    console.log(res)
      this.detectedmsg = res.Message;
      this.otp = this.detectedmsg.substr(26,6);
      this.otpInput.otp1 = this.otp[0];
      this.otpInput.otp2 = this.otp[1];
      this.otpInput.otp3 = this.otp[2];
      this.otpInput.otp4 = this.otp[3];
      this.otpInput.otp5 = this.otp[4];
      this.otpInput.otp6 = this.otp[5];
      // this.verifyotp();
  }).catch((error: any) =>{
    console.error(error)
  });
 
    // }
   }



  next(el1,el,event) {
    
    if(event.target.value <= 9 && event.target.value >=0 ){
      this.otp = this.otp.concat(event.target.value);
      el.setFocus();
      if(event.key == 'Backspace'){
        el1.setFocus();
      }
    }else{
      if(event.target.value == ''){
        this.otp = this.otp.substring(0, 0);
        el1.setFocus();
      }
    }
  }

  ngDoCheck(){
    // if(this.otpInput.otp6 !== '' && this.otpInput.otp6 !== null ){
    if(this.otp !== '' && this.otp.length == 6 ){    
      this.buttonflag = true;
    }else{
      this.buttonflag = false;
    }
   }

  shift(el1,el2,event,n){
    if(event.target.value == ''){
      this.otp = this.otp.substring(0,n);
     el2.setFocus();
    }else{
      if(event.target.value >=0 && event.target.value <=9){
        if(this.otp.length !== (n+1)){
          this.otp = this.otp.concat(event.target.value);
          el1.setFocus();
        }else{
          el1.setFocus();
        }
      }
    }
  }
 
  final(el,event){
    if(event.target.value == ''){
      this.otp = this.otp.substring(0, 5);
      el.setFocus();
     }else{
       this.otp = this.otp.concat(event.target.value);
    // this.verifyotp();
     }
    console.log(this.otp);

  }

  verifyotp(){
    if(this.otp.length == 6){
        this.userService.verifyOTP(this.mobileObj.numberWithCountryCode,this.otp).then((res:any)=>{
          console.log(res,"res"); 
          if(res.message == 'OTP verified success'){
            this.selecttype();
          }else{
            this.initOtpInput();
          }
         },(err)=>{
          this.initOtpInput();
         })
    }else{
      this.alert.presentAlert("Error",Config.CompleteOTPError);
      this.initOtpInput();
    }
  }
  initOtpInput(){
    this.otpInput = {
      otp1 : "",
      otp2 : "",
      otp3 : "",
      otp4 : "",
      otp5 : "",
      otp6 : ""
    }
    this.otp = '';
  }


  selecttype(){
    this.userService.getAllUsers(this.mobileObj.mobile).then((res:any)=>{
      if(res && res.length == 0){
        this.r.navigate(['/create-account'],{
          queryParams:{"mobileObj":JSON.stringify(this.mobileObj)}
        })
      }else{
        if(res[0].status == false){
          localStorage.removeItem("userProfile");
          localStorage.removeItem("loginUser");
          this.navCtrl.navigateRoot("/login");
          this.userService.toast.presentToastError("Your Account is Deactivated Please contact Admin.")
        }else{
          this.userService.login({"username":this.mobileObj.mobile,"password":this.mobileObj.mobile}).then((ress:any)=>{
            console.log(ress);
            this.userService.getUserDetails(ress.userId).then((resss:any)=>{
              console.log(resss);
              this.homeNavigation();
            })
          })
        }
      }
    })
   
  }

  homeNavigation(){
    if(this.userService.navigationdata){
      this.navCtrl.navigateBack(this.userService.navigationdata.redirectto);
      this.userService.navigationdata = null;
    }else{
      this.navCtrl.navigateForward('/app');
    }

  }



}
